"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

export default function BrandLoginPage() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || "Invalid credentials");
        return;
      }

      router.push("/brand/dashboard");
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="brand-auth">
      <div className="brand-auth__card">
        <div className="brand-auth__header">
          <h1 className="brand-auth__title">DressingRoom</h1>
          <p className="brand-auth__subtitle">for Brands</p>
        </div>

        <form onSubmit={handleSubmit} className="brand-auth__form">
          {error && <div className="brand-auth__error">{error}</div>}

          <div className="field-group">
            <label className="field-label">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="brand-input"
              placeholder="you@brand.com"
            />
          </div>

          <div className="field-group">
            <label className="field-label">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="brand-input"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            className="button button--primary button--block"
            disabled={loading}
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>

        <p className="brand-auth__footer">
          Don&apos;t have an account?{" "}
          <a href="/brand/signup" className="brand-auth__link">
            Create one
          </a>
        </p>
      </div>
    </div>
  );
}
